import { Card } from 'antd';
import React from 'react';
import { ROUTES } from '../../../common/constants';
import GoBackButton from '../../../components/GoBackButton';
import Portal from '../../../components/Portal';
import ToyDetailsContent from '../components/ToyDetailsContent';

const ViewToy = (props) => {
  const { match: { params: { id } = {} } = {} } = props;
  return (
    <>
      <Portal portalId="header-title-content">
        <GoBackButton customLink={ROUTES?.INVENTORY} />
        <div className="portal-header">View Toy</div>
      </Portal>
      <Card className="full-height-with-nav" title="Toy Details">
        <ToyDetailsContent toyId={id} />
      </Card>
    </>
  );
};

export default ViewToy;
